// back to top
document.addEventListener("DOMContentLoaded", function () {
  var backToTopButton = document.querySelector(".so-backtop");

  backToTopButton.addEventListener("click", function (event) {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  });

  window.addEventListener("scroll", function () {
    var y = window.scrollY;
    if (y > 800) {
      backToTopButton.classList.add("so-opacity");
    } else {
      backToTopButton.classList.remove("so-opacity");
    }
  });
});
